export const CACHE_TIME = 60 * 1000 * 20; // 20 minutes

export const screenshotConfig = {
  bitrate: 400, // equals 640x360
  bitrateFeatured: 2000, // equals 1280x720
  offsetInSeconds: 45,
  refreshInterval: 60,
  fileType: 'jpg',
};

export const socketServiceConfig = {
  enabled: true,
  eventTimeout: 2000,
  maxDelay: 300000,
  interval: 250,
  maxAge: 900000,
};
